/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Navigate, Route, useLocation } from 'react-router-dom';
import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';
import {
  getRiskDetailsTabUrl,
  RELEASES_ROUTE_NAME,
  RiskDetailsTab,
  RISKS_ROUTE_NAME,
  useScaBaseUrl,
} from '~shared/helpers/sca-urls';
import { useCurrentProjectRiskId } from '../hooks/useCurrentProjectRiskId';
import { LICENSE_ROUTE_NAME, PROJECT_LICENSE_ROUTE_NAME } from '../utils/urls';

const LicenseProfileApp = lazyLoadComponent(() => import('./license-profile/LicenseProfileApp'));
const LicenseProfileListApp = lazyLoadComponent(
  () => import('./license-profile-list/LicenseProfileListApp'),
);
const ReleaseListApp = lazyLoadComponent(() => import('./releases-list/ReleaseListApp'));
const ReleaseDetailsApp = lazyLoadComponent(() => import('./release-details/ReleaseDetailsApp'));
const ReleaseRisksApp = lazyLoadComponent(() => import('./risks-list/RisksApp'));
const RiskChangelogTab = lazyLoadComponent(() => import('./risk-details/RiskChangelogTab'));
const RiskDetailsApp = lazyLoadComponent(() => import('./risk-details/RiskDetailsApp'));
const RiskDetailsWhat = lazyLoadComponent(() => import('./risk-details/what/RiskDetailsWhat'));
const RiskDetailsHow = lazyLoadComponent(() => import('./risk-details/RiskDetailsHow'));
const RiskDetailsWhere = lazyLoadComponent(() => import('./risk-details/RiskDetailsWhere'));
const RisksContainer = lazyLoadComponent(() => import('./risks-list/RisksContainer'));
const LicenseProfileProjectApp = lazyLoadComponent(
  () => import('./license-profile-project/LicenseProfileProjectApp'),
);

export const licenseRoutes = (
  <>
    <Route element={<LicenseProfileListApp />} path={LICENSE_ROUTE_NAME} />
    <Route element={<LicenseProfileApp />} path={`${LICENSE_ROUTE_NAME}/show`} />
  </>
);

function RiskDetailsRedirect() {
  const { riskId } = useCurrentProjectRiskId();
  const { search } = useLocation();
  const baseUrl = useScaBaseUrl();
  return (
    <Navigate
      replace
      to={getRiskDetailsTabUrl({ riskId, tab: RiskDetailsTab.WHAT }, search, baseUrl)}
    />
  );
}

export const projectRoutes = (
  <>
    <Route element={<ReleaseListApp />} path={RELEASES_ROUTE_NAME} />
    <Route element={<ReleaseDetailsApp />} path={`${RELEASES_ROUTE_NAME}/:releaseId`} />
    <Route element={<RisksContainer />}>
      <Route element={<ReleaseRisksApp />} path={`${RISKS_ROUTE_NAME}`} />
      <Route element={<RiskDetailsApp />} path={`${RISKS_ROUTE_NAME}/:riskId`}>
        <Route element={<RiskDetailsWhat />} path="what" />
        <Route element={<RiskDetailsHow />} path="how" />
        <Route element={<RiskDetailsWhere />} path="where" />
        <Route element={<RiskDetailsRedirect />} index />
        <Route element={<RiskChangelogTab />} path="activity" />
      </Route>
    </Route>
    <Route element={<LicenseProfileProjectApp />} path={PROJECT_LICENSE_ROUTE_NAME} />
  </>
);
